module.exports = __webpack_public_path__ + "img/expand.08b30a67.svg";